import React, { Component } from 'react';
import { Form, Select, Spin, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  CategoriesSelect,
  CitiesSelectV2,
  CountriesSelectV2,
} from 'components';
import { ProjectsActions } from 'redux/actions';
import pickBy from 'loadsh/pickBy';
import identity from 'loadsh/identity';
import {
  Container,
  formLayout,
  formValidateMessages,
  H1,
  FormWrapper,
  SpaceBetween,
  SecondaryButton,
  PrimaryButtonV2,
  AddSelector,
  AddFormItemLabel,
} from 'utils';

const FormItem = Form.Item;
const { Option } = Select;

class BasicsEdit extends Component {
  formRef = React.createRef();

  static propTypes = {
    updateDraft: PropTypes.func.isRequired,
    project: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    isUniq: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
    currentStep: PropTypes.number.isRequired,
    setCanMove: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    selectedStep: PropTypes.number.isRequired,
    setSubmitFromModal: PropTypes.func.isRequired,
    handleExitEditForm: PropTypes.func.isRequired,
  };

  onFinish = () => {
    this.props.handleSteps(2);
  };

  getContent = (content, name) => {
    this.formRef.current.setFieldsValue({ [name]: content });
  };

  onReturn = () => {
    this.props.handleExitEditForm();
  };

  render() {
    const {
      project,
      loading,
      // isUniq,
      setCanMove,
      projectId,
    } = this.props;
    console.log(projectId, 'project--> ', project);

    return (
      <Container className="" style={{maxWidth: 480}}>
        <Spin spinning={projectId ? loading : false}>
          <H1>Grundlegendes</H1>
          <Form
            {...formLayout}
            ref={this.formRef}
            onChange={(e) => {
              return setCanMove(false);
            }}
            name="project-details"
            onFinish={this.onFinish}
            validateMessages={formValidateMessages}
            initialValues={
              projectId ? pickBy(project.categoryType, identity) : ''
            }
          >
            <div>
              <FormWrapper>
                <>
                  <Tooltip
                    title="Falls du das ändern möchtest, wende dich an unser Support-Team."
                    placement="bottom"
                    color="#000"
                    overlayInnerStyle={{ color: '#fff', borderRadius: '8px' }}
                    arrow={true}
                  >
                    <FormItem
                      name="user_type"
                      label={
                        <AddFormItemLabel>Unternehmenstyp</AddFormItemLabel>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: 'Unternehmenstyp ist erforderlich',
                        },
                      ]}
                      initialValue={
                        projectId && project?.business_type
                          ? project.business_type
                          : 'individual'
                      }
                    >
                      <AddSelector
                        placeholder="Typ auswählen"
                        style={{ width: '100%' }}
                        disabled={true}
                      >
                        <Option key={'individual'}>Privatperson</Option>
                        <Option key={'non_profit'}>
                          Verein oder Genossenschaft
                        </Option>
                        <Option key={'company'}>Kapitalgesellschaft</Option>
                        <Option key={'government_entity'}>
                          Personengesellschaft
                        </Option>
                      </AddSelector>
                    </FormItem>
                  </Tooltip>

                  <CategoriesSelect disabled={true} />

                  <Tooltip
                    title="Falls du das ändern möchtest, wende dich an unser Support-Team."
                    placement="bottom"
                    color="#000"
                    overlayInnerStyle={{ color: '#fff', borderRadius: '8px' }}
                    arrow={true}
                  >
                    <FormItem
                      name="project_type"
                      label={<AddFormItemLabel>Typ</AddFormItemLabel>}
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: 'Typ ist erforderlich',
                        },
                      ]}
                    >
                      <AddSelector
                        placeholder="Typ auswählen"
                        style={{ width: '100%' }}
                        disabled={true}
                      >
                        <Option key={'partial'}>Nicht-Gewinnorientiert</Option>
                        <Option key={'all'}>Gewinnorientiert</Option>
                      </AddSelector>
                    </FormItem>
                  </Tooltip>

                  <CountriesSelectV2
                    countryValue={project?.categoryType?.country}
                    disabled={true}
                  />

                  <CitiesSelectV2
                    cityValue={project?.categoryType?.city}
                    countryValue={project?.categoryType?.country}
                    disabled={true}
                  />

                  <div>
                    <Tooltip>
                      <FormItem
                        name="learned_about"
                        label={
                          <AddFormItemLabel>
                            Woher kennst du commonsplace?
                          </AddFormItemLabel>
                        }
                        required={false}
                        rules={[
                          {
                            required: true,
                            message: 'erforderlich',
                          },
                        ]}
                      >
                        <AddSelector
                          placeholder="Antwort auswählen"
                          options={[
                            { value: 'Social Media', label: 'Social Media' },
                            {
                              value: 'Freunde und Familie',
                              label: 'Freunde und Familie',
                            },
                            { value: 'WhatsApp', label: 'WhatsApp' },
                            { value: 'Newsletter', label: 'Newsletter' },
                            { value: 'Google Suche', label: 'Google Suche' },
                            {
                              value:
                                'Printmedien wie Plakat oder Flyer von commonsplace',
                              label: 'Printmedien wie Plakat oder Flyer',
                            },
                            {
                              value: 'Facebook/Instagram Werbung',
                              label: 'Facebook/Instagram Werbung',
                            },
                            { value: 'Andere', label: 'Andere' },
                          ]}
                          style={{ width: '100%' }}
                          value={project?.categoryType?.learned_about}
                          disabled={true}
                        />
                      </FormItem>
                    </Tooltip>
                  </div>
                </>
              </FormWrapper>
            </div>

            <FormItem>
              <SpaceBetween>
                <SecondaryButton
                  type="button"
                  minWidth="120px"
                  onClick={this.onReturn}
                >
                  <p>Zurück zur Projektübersicht</p>
                </SecondaryButton>
              </SpaceBetween>
            </FormItem>
          </Form>
        </Spin>
      </Container>
    );
  }
}
const mapStateToProps = (state) => {
  const { currentStep, project, loading, errors, isUniq } = state.projects;
  return {
    currentStep,
    project,
    loading,
    errors,
    isUniq,
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleSteps: (step) => dispatch(ProjectsActions.handleSteps(step)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BasicsEdit);
